export const setProfileData = (data) => ({
  type: "SET_PROFILE_DATA",
  payload: data,
});
export const setLoggedInsFalse = (data) => ({
  type: "SET_LOGGEDINS_False",
  payload: data,
});
